import { render, staticRenderFns } from "./CostsAtExpirationSection.vue?vue&type=template&id=27c2857e"
import script from "./CostsAtExpirationSection.vue?vue&type=script&lang=js"
export * from "./CostsAtExpirationSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports